import classNames from "classnames";
import { HTMLAttributeAnchorTarget } from "react";
import { Link, To } from "react-router-dom";

import styles from "./index.module.scss";

interface ICustomLinkProps {
  to: To;
  target?: HTMLAttributeAnchorTarget;
  isPrimary?: boolean;
  isDisabled?: boolean;
  className?: string;
}

function DisabledLink({
  isPrimary,
  className,
  children,
}: React.PropsWithChildren<Pick<ICustomLinkProps, "isPrimary" | "className">>) {
  return (
    <span
      className={classNames(styles.container, className, {
        [styles.primary]: isPrimary,
      })}>
      {children}
    </span>
  );
}

function CustomLink({
  to,
  target = "_self",
  children,
  className = "",
  isPrimary = false,
  isDisabled = false,
}: React.PropsWithChildren<ICustomLinkProps>) {
  if (isDisabled) {
    return (
      <DisabledLink isPrimary={isPrimary} className={className}>
        {children}
      </DisabledLink>
    );
  }

  return (
    <Link
      to={to}
      target={target}
      className={classNames(styles.container, className, {
        [styles.primary]: isPrimary,
      })}>
      {children}
    </Link>
  );
}

export default CustomLink;
